<template>
  <div
    id="popupContainer"
    v-bind:style="{
      display: executedOnce ? 'none' : p_isVisible ? 'block' : 'none'
    }"
  >
    <div
      v-bind:style="{
        display: p_isLoadingPopup ? 'block' : 'none'
      }"
      v-if="p_isLoadingPopup"
      id="loadingPopup"
    >
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      v-bind:style="{
        display: p_isLoadingPopup ? 'none' : 'block'
      }"
      id="resetSettingsPopup"
    >
      <div v-if="!p_isLoadingPopup" id="notLoadingPopup">
        <i
          v-if="p_isError"
          id="errorPopupColor"
          class="fal fa-times-circle"
        ></i>
        <i
          v-if="p_isSuccessful"
          id="successfulPopupColor"
          class="fal fa-circle-check"
        ></i>
        <i
          v-if="p_isWarning"
          id="warningPopupColor"
          class="fal fa-triangle-exclamation"
        ></i>
        <i v-if="p_isInfo" class="fal fa-info-square"></i>
        <h2>{{ p_header }}</h2>
        <p class="text">{{ p_text }}</p>
      </div>
      <button
        v-if="!p_isLoadingPopup"
        @click="hidePopup"
        id="closePopupBtn"
        class="button-standard brand-color"
      >
        Verstanden
      </button>
    </div>
  </div>
</template>

<script>
export default {
  //TODO: Error Symbol umändern
  props: {
    p_text: String,
    p_header: String,
    p_isError: {
      default: false,
      type: Boolean
    },
    p_isWarning: {
      default: false,
      type: Boolean
    },
    p_isInfo: {
      default: false,
      type: Boolean
    },
    p_isSuccessful: {
      default: false,
      type: Boolean
    },
    p_isVisible: {
      default: false,
      type: Boolean
    },
    p_isLoadingPopup: {
      default: false,
      type: Boolean
    },
    p_isExecutedOnceIgnored: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      executedOnce: false
    };
  },
  methods: {
    hidePopup() {
      if (!this.p_isExecutedOnceIgnored) {
        this.executedOnce = true;
      }
      this.$parent.hidePopup();
    },
    changePopUpStyle() {
      var popUpStlye = document.getElementById("resetSettingsPopup");
      popUpStlye.style.backgroundColor = "transparent";
      popUpStlye.style.border = "none";
      popUpStlye.style.boxShadow = "none";
    }
  }
};
</script>

<style language="css">
@import "../../scss/popup/style.css";
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #c28562;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/configurator/Popup.vue